import { message } from "antd";
import api from "../../config/base";
import {
  CREATE_USER_ERROR,
  CREATE_USER_SUCCESS,
  DELETE_USER_ERROR,
  DELETE_USER_SUCCESS,
  FETCH_USERS_ERROR,
  FETCH_USERS_SUCCESS,
  FETCH_ONE_USER_SUCCESS,
  FETCH_ONE_USER_ERROR,
  UPDATE_USER_ERROR,
  UPDATE_USER_SUCCESS,
} from "./types";

export const getAllUsers = () => async (dispatch) => {
  try {
    const res = await api.get(`users`);
    dispatch({
      type: FETCH_USERS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_USERS_ERROR,
      payload: error.message,
    });
  }
};

export const getOneUser = (_id) => async (dispatch) => {
  try {
    const res = await api.get(`users/${_id}`);
    dispatch({
      type: FETCH_ONE_USER_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ONE_USER_ERROR,
      payload: error.message,
    });
  }
};

export const createUser = (user) => async (dispatch) => {
  try {
    const res = await api.post(`users`, user);
    dispatch({
      type: CREATE_USER_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_USER_ERROR,
      payload: error.message,
    });
  }
};

export const deleteUser = (_id) => async (dispatch) => {
  try {
    const res = await api.delete(`users/${_id}`);
    dispatch({
      type: DELETE_USER_SUCCESS,
      payload: res.data._id,
    });
  } catch (error) {
    dispatch({
      type: DELETE_USER_ERROR,
      payload: error.message,
    });
  }
};

export const updateUser = (_id, user) => async (dispatch) => {
  try {
    const res = await api.put(`users/${_id}`, user);
    dispatch({
      type: UPDATE_USER_SUCCESS,
      payload: res.data,
    });
    message.success("User updated successfully.");
  } catch (error) {
    message.error(error.message);
    dispatch({
      type: UPDATE_USER_ERROR,
      payload: error.message,
    });
  }
};
